import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/autoplay";

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll<HTMLElement>(".slider-block");

  sliders.forEach((sliderRoot) => {
    const nextBtn = sliderRoot.querySelector(".swiper-custom-next") as HTMLElement;
    const prevBtn = sliderRoot.querySelector(".swiper-custom-prev") as HTMLElement;

    const slidesToShow = JSON.parse(sliderRoot.dataset.slidesToShow || "{}");
    const centeredSlides = sliderRoot.dataset.centeredSlides === "true";
    const autoplay = sliderRoot.dataset.autoplay === "true";

    new Swiper(sliderRoot, {
      modules: [Autoplay, Navigation],
      slidesPerView: slidesToShow.mobile,
      loop: true,

      autoplay: autoplay
        ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      spaceBetween: 32,
      centeredSlides: centeredSlides,
      breakpoints: {
        768: { slidesPerView: slidesToShow.tablet },
        1024: { slidesPerView: slidesToShow.desktop },
        1900: { slidesPerView: slidesToShow.widerScreen },
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
  });
});
